import { render, staticRenderFns } from "./import-sales-data.vue?vue&type=template&id=63af920c&scoped=true"
import script from "./import-sales-data.vue?vue&type=script&lang=js"
export * from "./import-sales-data.vue?vue&type=script&lang=js"
import style0 from "./import-sales-data.vue?vue&type=style&index=0&id=63af920c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af920c",
  null
  
)

export default component.exports